import type { ModuleKey } from "../../shared/modules";
import { trpc } from "./trpc";

/**
 * Moduli accesi per l'azienda di chi sta usando l'app.
 *
 * Finche la risposta non arriva l'insieme resta vuoto, quindi non si vede niente:
 * meglio una voce che compare un istante dopo di una voce che compare e poi sparisce,
 * promettendo una funzione che quell'azienda non ha comprato.
 */
export function useActiveModules() {
  const query = trpc.modules.list.useQuery(undefined, { staleTime: 5 * 60 * 1000 });
  const attivi = new Set<ModuleKey>((query.data ?? []).filter((modulo) => modulo.active).map((modulo) => modulo.key));
  return { attivi, caricato: query.isSuccess };
}

/**
 * Filtro delle voci di navigazione: una voce senza modulo vale per tutti.
 * Il vincolo su `label` non e un capriccio: senza una proprieta in comune TypeScript
 * accetterebbe qualsiasi oggetto, e un errore di battitura su `module` passerebbe liscio.
 */
export function visibileConModuli<T extends { label: string; module?: ModuleKey }>(
  voci: T[],
  attivi: Set<ModuleKey>,
) {
  return voci.filter((voce) => !voce.module || attivi.has(voce.module));
}
